import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './taskpane/App';
import { ComposePane } from './taskpane/ComposePane';
import { isComposeMode } from './lib/compose';

// Office.js must signal ready before we touch any mailbox API. The same taskpane
// serves both surfaces: the read button shows <App> (log the open email), the
// compose button shows <ComposePane> (templates + tracked send).
Office.onReady(() => {
  const container = document.getElementById('root');
  if (!container) throw new Error('Root element missing');
  const Root = isComposeMode() ? ComposePane : App;
  createRoot(container).render(
    <StrictMode>
      <Root />
    </StrictMode>,
  );
});
